import { createSlice } from '@reduxjs/toolkit';

import { CourseTypes, INITIAL_LIST_PARAMS } from 'config';
import { WorkoutState } from '../../types/course';

const initialState: WorkoutState = {
  isLoading: false,
  courseList: {},
  courseListParams: { ...INITIAL_LIST_PARAMS, course_type: CourseTypes.WORKOUT },
};

const slice = createSlice({
  name: 'workout',
  initialState,
  reducers: {
    workoutStartLoading(state) {
      state.isLoading = true;
    },

    workoutHasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    workoutResetError(state) {
      state.error = undefined;
    },

    getWorkoutListSuccess(state, action) {
      state.isLoading = false;
      state.courseList = action.payload;
    },

    getWorkoutSuccess(state, action) {
      state.isLoading = false;
      state.course = action.payload;
    },

    setWorkoutListParams(state, action) {
      state.courseListParams = action.payload;
    },

    clearWorkout(state) {
      state.course = undefined;
    },

    clearWorkoutList(state) {
      state.courseList = {};
    },

    clearWorkoutParameters(state) {
      state.courseListParams = {};
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  workoutStartLoading,
  workoutHasError,
  workoutResetError,
  getWorkoutListSuccess,
  getWorkoutSuccess,
  setWorkoutListParams,
  clearWorkout,
  clearWorkoutParameters,
  clearWorkoutList,
} = slice.actions;
